import { render, staticRenderFns } from "./spoiler.vue?vue&type=template&id=1087ee72&"
import script from "./spoiler.vue?vue&type=script&lang=js&"
export * from "./spoiler.vue?vue&type=script&lang=js&"
import style0 from "./spoiler.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports